import {
  AssemblyDraftDocumentStore,
  cloneAssemblyDocument,
  type ModelAssetNode,
  type ProjectModelLoadResult,
} from '@puppycad/cad-core'

export interface InitializeAssemblyDraftDocumentStoreFromRootInput {
  /** 当前 OpenProject 根节点映射后的模型资产根节点。 */
  readonly root: ModelAssetNode
  /** cad-core 项目模型加载事务产出的结构化结果。 */
  readonly loadResult: ProjectModelLoadResult
  /** 当前编辑会话持有的装配草稿文档仓库。 */
  readonly store: AssemblyDraftDocumentStore
}

/**
 * 使用根节点 `_assembly.json` 初始化装配草稿文档仓库。
 *
 * 设计说明：草稿 store 只承担“可修改副本”的角色，不负责 dirty 判断和提交时机。
 * 若当前根节点没有装配文档，说明它不是可编辑装配入口，必须清掉旧记录，避免后续
 * 子节点切换误写到上一个项目的草稿。
 *
 * @param input 根节点、加载结果和目标 store。
 */
export function initializeAssemblyDraftDocumentStoreFromRoot(
  input: InitializeAssemblyDraftDocumentStoreFromRootInput,
): void {
  const baseAssemblyDocument = input.loadResult.assemblyDocumentsByNodeKey.get(input.root.nodeKey)

  if (!baseAssemblyDocument) {
    input.store.remove(input.root.nodeKey)
    return
  }

  input.store.set({
    rootNodeKey: input.root.nodeKey,
    baseCommitId: input.root.commitId,
    baseAssemblyDocument,
    workingAssemblyDocument: cloneAssemblyDocument(baseAssemblyDocument),
  })
}
